// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTADocumentContentEdcSourceRulesInner } from './dta-document-content-edc-source-rules-inner';
import {
    DTADocumentContentEdcSourceRulesInnerFromJSON,
    DTADocumentContentEdcSourceRulesInnerFromJSONTyped,
    DTADocumentContentEdcSourceRulesInnerToJSON,
    DTADocumentContentEdcSourceRulesInnerToJSONTyped,
} from './dta-document-content-edc-source-rules-inner';
import type { DTADocumentContentProtocolSource } from './dta-document-content-protocol-source';
import {
    DTADocumentContentProtocolSourceFromJSON,
    DTADocumentContentProtocolSourceFromJSONTyped,
    DTADocumentContentProtocolSourceToJSON,
    DTADocumentContentProtocolSourceToJSONTyped,
} from './dta-document-content-protocol-source';
import type { DTADocumentContentSectionsInner } from './dta-document-content-sections-inner';
import {
    DTADocumentContentSectionsInnerFromJSON,
    DTADocumentContentSectionsInnerFromJSONTyped,
    DTADocumentContentSectionsInnerToJSON,
    DTADocumentContentSectionsInnerToJSONTyped,
} from './dta-document-content-sections-inner';
import type { DataQualityRules } from './data-quality-rules';
import {
    DataQualityRulesFromJSON,
    DataQualityRulesFromJSONTyped,
    DataQualityRulesToJSON,
    DataQualityRulesToJSONTyped,
} from './data-quality-rules';
import type { TestConceptGroup } from './test-concept-group';
import {
    TestConceptGroupFromJSON,
    TestConceptGroupFromJSONTyped,
    TestConceptGroupToJSON,
    TestConceptGroupToJSONTyped,
} from './test-concept-group';
import type { DTADocumentContentDataElementsInner } from './dta-document-content-data-elements-inner';
import {
    DTADocumentContentDataElementsInnerFromJSON,
    DTADocumentContentDataElementsInnerFromJSONTyped,
    DTADocumentContentDataElementsInnerToJSON,
    DTADocumentContentDataElementsInnerToJSONTyped,
} from './dta-document-content-data-elements-inner';
import type { CodelistItem } from './codelist-item';
import {
    CodelistItemFromJSON,
    CodelistItemFromJSONTyped,
    CodelistItemToJSON,
    CodelistItemToJSONTyped,
} from './codelist-item';
import type { DTADocumentContentAssessmentsInner } from './dta-document-content-assessments-inner';
import {
    DTADocumentContentAssessmentsInnerFromJSON,
    DTADocumentContentAssessmentsInnerFromJSONTyped,
    DTADocumentContentAssessmentsInnerToJSON,
    DTADocumentContentAssessmentsInnerToJSONTyped,
} from './dta-document-content-assessments-inner';
import type { DTADocumentContentUserGuide } from './dta-document-content-user-guide';
import {
    DTADocumentContentUserGuideFromJSON,
    DTADocumentContentUserGuideFromJSONTyped,
    DTADocumentContentUserGuideToJSON,
    DTADocumentContentUserGuideToJSONTyped,
} from './dta-document-content-user-guide';
import type { TransferMetadataSchema } from './transfer-metadata-schema';
import {
    TransferMetadataSchemaFromJSON,
    TransferMetadataSchemaFromJSONTyped,
    TransferMetadataSchemaToJSON,
    TransferMetadataSchemaToJSONTyped,
} from './transfer-metadata-schema';
import type { ExtractionMetadata } from './extraction-metadata';
import {
    ExtractionMetadataFromJSON,
    ExtractionMetadataFromJSONTyped,
    ExtractionMetadataToJSON,
    ExtractionMetadataToJSONTyped,
} from './extraction-metadata';

/**
 * 
 * @export
 * @interface DTADocumentContent
 */
export interface DTADocumentContent {
    /**
     * 
     * @type {object}
     * @memberof DTADocumentContent
     */
    _ai_prepopulation_metadata?: object;
    /**
     * 
     * @type {Array<DTADocumentContentEdcSourceRulesInner>}
     * @memberof DTADocumentContent
     */
    _edc_source_rules?: Array<DTADocumentContentEdcSourceRulesInner>;
    /**
     * 
     * @type {DTADocumentContentProtocolSource}
     * @memberof DTADocumentContent
     */
    _protocol_source?: DTADocumentContentProtocolSource;
    /**
     * Protocol assessments copied during DTA creation
     * @type {Array<DTADocumentContentAssessmentsInner>}
     * @memberof DTADocumentContent
     */
    assessments?: Array<DTADocumentContentAssessmentsInner>;
    /**
     * 
     * @type {Array<CodelistItem>}
     * @memberof DTADocumentContent
     */
    code_lists?: Array<CodelistItem>;
    /**
     * 
     * @type {object}
     * @memberof DTADocumentContent
     */
    dataIngestionParameters?: object;
    /**
     * 
     * @type {Array<DTADocumentContentDataElementsInner>}
     * @memberof DTADocumentContent
     */
    data_elements?: Array<DTADocumentContentDataElementsInner>;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContent
     */
    data_purpose?: string;
    /**
     * 
     * @type {DataQualityRules}
     * @memberof DTADocumentContent
     */
    data_quality_rules?: DataQualityRules;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContent
     */
    data_stream_id?: string;
    /**
     * SDTM domain code extracted during DTA parsing
     * @type {string}
     * @memberof DTADocumentContent
     */
    domain?: string;
    /**
     * 
     * @type {ExtractionMetadata}
     * @memberof DTADocumentContent
     */
    extraction_metadata?: ExtractionMetadata;
    /**
     * 
     * @type {object}
     * @memberof DTADocumentContent
     */
    field_mappings?: object;
    /**
     * 
     * @type {object}
     * @memberof DTADocumentContent
     */
    ingestion_parameters?: object;
    /**
     * 
     * @type {object}
     * @memberof DTADocumentContent
     */
    operational_agreements?: object;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContent
     */
    parsed_study_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DTADocumentContent
     */
    pk_inferred?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DTADocumentContent
     */
    require_zip?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DTADocumentContent
     */
    required_columns?: Array<string>;
    /**
     * 
     * @type {Array<DTADocumentContentSectionsInner>}
     * @memberof DTADocumentContent
     */
    sections?: Array<DTADocumentContentSectionsInner>;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContent
     */
    study_phase?: string;
    /**
     * 
     * @type {Array<TestConceptGroup>}
     * @memberof DTADocumentContent
     */
    test_concepts?: Array<TestConceptGroup>;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContent
     */
    therapeutic_area?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof DTADocumentContent
     */
    timepoints?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContent
     */
    title?: string;
    /**
     * 
     * @type {object}
     * @memberof DTADocumentContent
     */
    transfer_metadata?: object;
    /**
     * 
     * @type {TransferMetadataSchema}
     * @memberof DTADocumentContent
     */
    transfer_metadata_schema?: TransferMetadataSchema;
    /**
     * 
     * @type {DTADocumentContentUserGuide}
     * @memberof DTADocumentContent
     */
    user_guide?: DTADocumentContentUserGuide;
    /**
     * 
     * @type {Array<object>}
     * @memberof DTADocumentContent
     */
    visits?: Array<object>;
}

/**
 * Check if a given object implements the DTADocumentContent interface.
 */
export function instanceOfDTADocumentContent(value: object): value is DTADocumentContent {
    return true;
}

export function DTADocumentContentFromJSON(json: any): DTADocumentContent {
    return DTADocumentContentFromJSONTyped(json, false);
}

export function DTADocumentContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADocumentContent {
    if (json == null) {
        return json;
    }
    return {
        
        '_ai_prepopulation_metadata': json['_ai_prepopulation_metadata'] == null ? undefined : json['_ai_prepopulation_metadata'],
        '_edc_source_rules': json['_edc_source_rules'] == null ? undefined : ((json['_edc_source_rules'] as Array<any>).map(DTADocumentContentEdcSourceRulesInnerFromJSON)),
        '_protocol_source': json['_protocol_source'] == null ? undefined : DTADocumentContentProtocolSourceFromJSON(json['_protocol_source']),
        'assessments': json['assessments'] == null ? undefined : ((json['assessments'] as Array<any>).map(DTADocumentContentAssessmentsInnerFromJSON)),
        'code_lists': json['code_lists'] == null ? undefined : ((json['code_lists'] as Array<any>).map(CodelistItemFromJSON)),
        'dataIngestionParameters': json['dataIngestionParameters'] == null ? undefined : json['dataIngestionParameters'],
        'data_elements': json['data_elements'] == null ? undefined : ((json['data_elements'] as Array<any>).map(DTADocumentContentDataElementsInnerFromJSON)),
        'data_purpose': json['data_purpose'] == null ? undefined : json['data_purpose'],
        'data_quality_rules': json['data_quality_rules'] == null ? undefined : DataQualityRulesFromJSON(json['data_quality_rules']),
        'data_stream_id': json['data_stream_id'] == null ? undefined : json['data_stream_id'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'extraction_metadata': json['extraction_metadata'] == null ? undefined : ExtractionMetadataFromJSON(json['extraction_metadata']),
        'field_mappings': json['field_mappings'] == null ? undefined : json['field_mappings'],
        'ingestion_parameters': json['ingestion_parameters'] == null ? undefined : json['ingestion_parameters'],
        'operational_agreements': json['operational_agreements'] == null ? undefined : json['operational_agreements'],
        'parsed_study_id': json['parsed_study_id'] == null ? undefined : json['parsed_study_id'],
        'pk_inferred': json['pk_inferred'] == null ? undefined : json['pk_inferred'],
        'require_zip': json['require_zip'] == null ? undefined : json['require_zip'],
        'required_columns': json['required_columns'] == null ? undefined : json['required_columns'],
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(DTADocumentContentSectionsInnerFromJSON)),
        'study_phase': json['study_phase'] == null ? undefined : json['study_phase'],
        'test_concepts': json['test_concepts'] == null ? undefined : ((json['test_concepts'] as Array<any>).map(TestConceptGroupFromJSON)),
        'therapeutic_area': json['therapeutic_area'] == null ? undefined : json['therapeutic_area'],
        'timepoints': json['timepoints'] == null ? undefined : json['timepoints'],
        'title': json['title'] == null ? undefined : json['title'],
        'transfer_metadata': json['transfer_metadata'] == null ? undefined : json['transfer_metadata'],
        'transfer_metadata_schema': json['transfer_metadata_schema'] == null ? undefined : TransferMetadataSchemaFromJSON(json['transfer_metadata_schema']),
        'user_guide': json['user_guide'] == null ? undefined : DTADocumentContentUserGuideFromJSON(json['user_guide']),
        'visits': json['visits'] == null ? undefined : json['visits'],
    };
}

export function DTADocumentContentToJSON(json: any): DTADocumentContent {
    return DTADocumentContentToJSONTyped(json, false);
}

export function DTADocumentContentToJSONTyped(value?: DTADocumentContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_ai_prepopulation_metadata': value['_ai_prepopulation_metadata'],
        '_edc_source_rules': value['_edc_source_rules'] == null ? undefined : ((value['_edc_source_rules'] as Array<any>).map(DTADocumentContentEdcSourceRulesInnerToJSON)),
        '_protocol_source': DTADocumentContentProtocolSourceToJSON(value['_protocol_source']),
        'assessments': value['assessments'] == null ? undefined : ((value['assessments'] as Array<any>).map(DTADocumentContentAssessmentsInnerToJSON)),
        'code_lists': value['code_lists'] == null ? undefined : ((value['code_lists'] as Array<any>).map(CodelistItemToJSON)),
        'dataIngestionParameters': value['dataIngestionParameters'],
        'data_elements': value['data_elements'] == null ? undefined : ((value['data_elements'] as Array<any>).map(DTADocumentContentDataElementsInnerToJSON)),
        'data_purpose': value['data_purpose'],
        'data_quality_rules': DataQualityRulesToJSON(value['data_quality_rules']),
        'data_stream_id': value['data_stream_id'],
        'domain': value['domain'],
        'extraction_metadata': ExtractionMetadataToJSON(value['extraction_metadata']),
        'field_mappings': value['field_mappings'],
        'ingestion_parameters': value['ingestion_parameters'],
        'operational_agreements': value['operational_agreements'],
        'parsed_study_id': value['parsed_study_id'],
        'pk_inferred': value['pk_inferred'],
        'require_zip': value['require_zip'],
        'required_columns': value['required_columns'],
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(DTADocumentContentSectionsInnerToJSON)),
        'study_phase': value['study_phase'],
        'test_concepts': value['test_concepts'] == null ? undefined : ((value['test_concepts'] as Array<any>).map(TestConceptGroupToJSON)),
        'therapeutic_area': value['therapeutic_area'],
        'timepoints': value['timepoints'],
        'title': value['title'],
        'transfer_metadata': value['transfer_metadata'],
        'transfer_metadata_schema': TransferMetadataSchemaToJSON(value['transfer_metadata_schema']),
        'user_guide': DTADocumentContentUserGuideToJSON(value['user_guide']),
        'visits': value['visits'],
    };
}
